<template>
  <div>
    <PromoBgDesktop :title="'Как «Биттнер-Фарма» обучает своих сотрудников?'"/>

    <section class="page-section _with-border text-content">
      <div class="inner-width">
        <h2>«Вебинары не только помогают в обучении сотрудников, но и влияют на рост продаж»</h2>
        <p>
          Представительство всемирно известной компании «Биттнер» работает на российском рынке уже более 20 лет.
          Компания занимается продажей и продвижением таких лекарственных препаратов, как «Биттнер», «Ременс», «Афлубин»
          и другие, в аптечных сетях по всей стране. Для обучения сотрудников, работающих, в регионах, с 2013 года
          компания использует вебинары.
          <br><br>

          Сегодня в российском представительстве "Биттнер-Фарма" работают чуть больше 100 человек. "Наши сотрудники
          находятся в разных городах России, поэтому важно было наладить удобную связь. Вебинары дали нам такую
          возможность", — рассказывает Юлия Долгова, продукт-менеджер "Биттнер-Фарма".
        </p>
        <blockquote>
          Основная цель использования вебинаров в компании — обучение и поддержка сотрудников. Раньше для этого
          использовали Skype, но такой вариант не устраивал руководство, так как не позволял приглашать большое
          количество участников и имел ограниченный функционал.
        </blockquote>
        <p>
          «Платформу Линк Вебинары мы выбрали по рекомендациям партнеров, которые уже использовали вебинары в своей работе.
          Сначала, конечно, было непривычно пользоваться новым сервисом. Но, изучив книгу «Вебинар на 100%» и задав
          дополнительные вопросы сотрудникам техподдержки Линк Вебинар, мы во всем разобрались», - продолжает Юлия.
        </p>

        <h2>Как измерить эффективность?</h2>
        <p>
          Юлия Долгова с самого начала отвечала за внедрение вебинаров: вела проект, обучала коллег работе с платформой,
          отвечала на их вопросы. Сегодня каждый из 7 продукт-менеджеров компании, отвечающий за отдельное направление и
          продукты, организует и проводит собственные обучающие вебинары для коллег из регионов.
        </p>

        <div class="image-wrapper">
          <picture>
            <source
              v-lazy-load
              data-srcset="~/assets/img/clients-items/bittner_farma/bittner-farma-1.webp"
            >
            <img
              v-lazy-load
              data-src="~/assets/img/clients-items/bittner_farma/bittner-farma-1.jpg"
              alt="Как «Биттнер-Фарма» обучает своих сотрудников? | Фото 1"
              width="900"
              height="524"
            >
          </picture>
        </div>
        <p>
          После каждого вебинара ведется статистический учет: кто присутствовал на обучении, какой процент сотрудников
          получил новую информацию, насколько хорошо сотрудники эту информацию усвоили и т.д.
          <br><br>

          В конце вебинара проводятся онлайн-тесты, а для тех, кто на вебинарах не присутствовал, сохраняются записи
          вебинаров, которые сотрудники могут посмотреть в удобное им время. Эти данные помогают продукт-менеджерам в
          оценке работы региональных сотрудников и в планировании следующих вебинаров. А в компании, занимающей одну из
          лидирующих позиций на высококонкурентном рынке лекарственных препаратов, возможность быстро подстраиваться под
          изменения играет существенную роль.
          <br><br>

          «В первую очередь вебинары дают нам возможность обучать людей работе с продуктами, - подводит итог Юлия. - А
          знания, которые наши сотрудники получают на вебинарах, в дальнейшем напрямую влияют на продажи».
        </p>
      </div>
    </section>

    <Sharing
      :vk-link="'https://oauth.vk.com/authorize?client_id=-1&redirect_uri=https%3A%2F%2Fvk.com%2Fshare.php%3Furl%3Dhttps%3A%2F%2Fmts-link.ru%2Fclients%2Fbittner_farma%26comment%3D%25D0%259A%25D0%25BB%25D0%25B8%25D0%25B5%25D0%25BD%25D1%2582%2520Webinar%2520%25D0%25BA%25D0%25BE%25D0%25BC%25D0%25BF%25D0%25B0%25D0%25BD%25D0%25B8%25D1%258F%2520BITTNER%2520PHARMA%2520-%2520Mts-Link.ru&display=widget'"
    />

    <ClientsSeeMoreDesktop :clients-see-more="clientsSeeMore"/>
  </div>
</template>
<script>

import PromoBgDesktop from "~/components/Desktop/Common/PromoBgDesktop.vue";
import Sharing from "~/components/Common/Sharing.vue";
import ClientsSeeMoreDesktop from "~/components/Desktop/Clients/ClientsSeeMoreDesktop.vue";

export default {
  name: 'ClientsBittnerPharmaDesktop',
  components: {ClientsSeeMoreDesktop, Sharing, PromoBgDesktop},
  props: {
    clientsSeeMore: {
      type: Array,
      default: () => [],
    }
  },
};
</script>
<style lang="scss" scoped>
@import "assets/scss/client-desktop.scss";
</style>
